export const NETWORK_CONVERT_NAME: { [key: string]: string } = {
  ETH: 'Ethereum',
  BSC: 'BSC',
  TRON: 'Tron'
};
